import { render, staticRenderFns } from "./AppRecaptcha.vue?vue&type=template&id=332b5438&scoped=true"
import script from "./AppRecaptcha.vue?vue&type=script&lang=ts"
export * from "./AppRecaptcha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332b5438",
  null
  
)

export default component.exports